/** Panel login: `me` sets localStorage `staff_user_type` to Admin | Agent */
export function staffIsAdmin() {
  try {
    return String(localStorage.getItem('staff_user_type') || '').trim() === 'Admin';
  } catch (_) {
    return false;
  }
}
